import * as React from 'react';

import { useLoaderData, useNavigate } from 'react-router-dom';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import AddIcon from '@mui/icons-material/Add';

import EwpFab from '../components/EwpFab';
import Header from '../components/Header';

import { listAssessmentTypes } from '../models/assessmentTypes';

export async function loader() {
  const assessmentTypes = await listAssessmentTypes();
  return { assessmentTypes };
}

export default function AssessmentTypesListPage({ title = 'Assessment Types', ...props }) {
  const navigate = useNavigate();
  const { assessmentTypes } = useLoaderData();

  const navigateToType = (id) => {
    navigate(`/assessment-types/${id}`);
  };

  return (
    <Container component="main" maxWidth="md">
      <Header label={title} />

      <Grid container spacing={2}>
        {assessmentTypes.map((assessmentType) => (
          <Grid key={assessmentType.id} xs={12} sm={6} md={4}>
            <Card variant="outlined">
              <CardActionArea onClick={() => navigateToType(assessmentType.id)}>
                <CardContent>
                  <Typography variant="h6">{assessmentType.name}</Typography>
                  {assessmentType.description && (
                    <Typography variant="body2" color="text.secondary">
                      {assessmentType.description}
                    </Typography>
                  )}
                  <Typography variant="caption" color="text.secondary">
                    {assessmentType.species?.length || 0} species
                  </Typography>
                  {assessmentType.species?.length ? (
                    <Typography variant="body2" color="text.secondary">
                      {assessmentType.species.join(', ')}
                    </Typography>
                  ) : null}
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      <EwpFab onClick={() => navigate('/assessment-types/new')}>
        <AddIcon />
      </EwpFab>
    </Container>
  );
}
